export const DEFAULT_CONFIGS = {
  primary_color: "#3372EE",
  banner_primary_color: "#3372EE",
  banner_primary_color_transparency: 80,
  logo_img: "/image/rsholding-logo.png",
  isotype_img: "/image/rsholding-isotipo.png",
  background_img: "/image/rsholding-fundo-cinza.jpg",
  title: "Plataforma Rs Holding",
  subtitle: "",
  form_position: "LEFT",
  terms_condition_show: "0",
  terms_condition_text: null,
};
